import Vue from "vue";

import Vuex from "vuex";

import { data } from "../shared";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    video: {},
    hotspots: [],
    selectedHotspot: {},
    isPlaying: false,
    status: "idle"
  },
  mutations: {
    setVideo(state, video) {
      state.video = video;
    },
    setHotspots(state, hotspots) {
      state.hotspots = hotspots;
    },
    selectHotspot(state, specs) {
      state.selectedHotspot = specs;
    },
    setVideoState(state, isPlaying) {
      state.isPlaying = !state.isPlaying;
    },
    setStatus(state, status) {
      state.status = status;
    }
  },
  actions: {
    async loadAllData({ commit }, api) {
      const allData = await data.getAllData(api);
      commit("setVideo", allData.video);
      commit("setHotspots", allData.hotspots);
    },
    selectHotspot({ commit }, specs) {
      if (this.state.status === "play") {
        return;
      }
      commit("selectHotspot", specs);
      commit("setStatus", "play");
    },
    setStatus({ commit }, status) {
      commit("setStatus", status);
    },
    reset({ commit }) {
      commit("selectHotspot", undefined);
      commit("setStatus", "reset");
    }
  },
  modules: {}
});
